<!-- user-profile.component.html -->
<div class="account-wrapper">
  <div class="account-card">
    <h2 class="card-title">User Profile</h2>
    <mat-divider></mat-divider>

    <div *ngIf="isLoading">Loading profile...</div>
    <div *ngIf="error">Error loading profile</div>

    <div *ngIf="!isLoading && !error" class="account-grid">
      <div class="profile-section">
        <img [src]="user?.profilePhoto || 'images/profile-placeholder.png'"
             alt="Profile Photo"
             class="profile-image" />
      </div>

      <div class="info-section">
        <h2 class="username">{{ user?.firstname }} {{ user?.lastname }}</h2>
        <p class="company-name"><strong>Company:</strong> {{ user?.company }}</p>
        <p class="email"><strong>Email:</strong> {{ user?.email }}</p>
        <p class="phone"><strong>Phone:</strong> {{ formatPhone(user?.phoneNumber) }}</p>
        <p class="job-title"><strong>Title:</strong> {{ user?.jobTitle }}</p>
      </div>
    </div>
  </div>
</div>